import { useContext } from 'react';

import { AuthContext, type AuthContextValue } from './rtk-auth-provider';

export const useAuthContext = (): AuthContextValue => {
  const ctx = useContext(AuthContext);

  if (ctx === null) {
    throw new Error(
      'useAuthContext hook must be used within an AuthContext.Provider',
    );
  }

  return ctx;
};
